import { withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withId = /*#__PURE__*/_withScopeId("data-v-7285d4cb");

_pushScopeId("data-v-7285d4cb");

var _hoisted_1 = {
  class: "p-relative"
};
var _hoisted_2 = {
  key: 0,
  class: "group"
};

_popScopeId();

export var render = /*#__PURE__*/_withId(function (_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock("div", _hoisted_1, [_createVNode("input", {
    ref: "btn",
    type: "button",
    class: "form-select",
    disabled: _ctx.disabled,
    readonly: _ctx.readonly,
    onMousedown: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.toggle();
    }),
    onKeydown: [_cache[2] || (_cache[2] = _withKeys(function () {
      return _ctx.keyDownBtnDelete && _ctx.keyDownBtnDelete.apply(_ctx, arguments);
    }, ["delete"])), _cache[3] || (_cache[3] = _withKeys(function () {
      return _ctx.keyDownBtn && _ctx.keyDownBtn.apply(_ctx, arguments);
    }, ["down"])), _cache[4] || (_cache[4] = _withKeys(function () {
      return _ctx.keyEnter && _ctx.keyEnter.apply(_ctx, arguments);
    }, ["enter"]))],
    title: _ctx.state.selectedItem ? _ctx.getText(_ctx.state.selectedItem, 1) : _ctx.title,
    value: _ctx.state.selectedItem ? _ctx.getText(_ctx.state.selectedItem, 1) : _ctx.title
  }, null, 40, ["disabled", "readonly", "title", "value"]), _createVNode("div", {
    class: ["list", {
      show: _ctx.state.showList
    }],
    "aria-expanded": _ctx.state.showList
  }, [_createVNode("input", {
    type: "text",
    ref: "txt",
    autocomplete: "off",
    class: "form-input",
    onInput: _cache[5] || (_cache[5] = function ($event) {
      return _ctx.input($event.target.value);
    }),
    onClick: _cache[6] || (_cache[6] = function () {
      return _ctx.focus && _ctx.focus.apply(_ctx, arguments);
    }),
    onBlur: _cache[7] || (_cache[7] = function () {
      return _ctx.reset && _ctx.reset.apply(_ctx, arguments);
    }),
    onFocus: _cache[8] || (_cache[8] = function () {
      return _ctx.focus && _ctx.focus.apply(_ctx, arguments);
    }),
    onKeyup: _cache[9] || (_cache[9] = _withKeys(function () {
      return _ctx.reset && _ctx.reset.apply(_ctx, arguments);
    }, ["esc"])),
    onKeydown: [_cache[10] || (_cache[10] = _withKeys(function () {
      return _ctx.keyDown && _ctx.keyDown.apply(_ctx, arguments);
    }, ["down"])), _cache[11] || (_cache[11] = _withKeys(function () {
      return _ctx.keyUp && _ctx.keyUp.apply(_ctx, arguments);
    }, ["up"])), _cache[12] || (_cache[12] = _withKeys(function () {
      return _ctx.keyEnter && _ctx.keyEnter.apply(_ctx, arguments);
    }, ["enter"]))]
  }, null, 544), _createVNode("ul", {
    ref: "list",
    class: {
      groped: _ctx.hasGroups
    }
  }, [(_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.visibleData, function (d, index) {
    return _openBlock(), _createBlock(_Fragment, {
      key: d.id
    }, [_ctx.hasGroups && (d.group && index === 0 || index > 0 && d.group !== _ctx.state.visibleData[index - 1].group) ? (_openBlock(), _createBlock("li", _hoisted_2, _toDisplayString(d.group), 1)) : _createCommentVNode("", true), _createVNode("li", {
      ref: "items",
      class: {
        selected: index === _ctx.state.selectedIndex
      },
      onMousedown: function onMousedown($event) {
        return _ctx.itemClick(d, index);
      },
      innerHTML: _ctx.getText(d)
    }, null, 42, ["onMousedown", "innerHTML"])], 64);
  }), 128))], 2)], 10, ["aria-expanded"])]);
});